import { ListLayout } from '@react-stately/layout'
import { ListState } from '@react-stately/list'
import { useLayoutEffect, useMemo } from 'react'

export function useListBoxLayout<T>(state: ListState<T>, isLoading: boolean) {
  let layout = useMemo(
    () =>
      new ListLayout<T>({
        estimatedRowHeight: 36,
        estimatedHeadingHeight: 32,
        padding: 0,
        loaderHeight: 40,
        placeholderHeight: 36,
      }),
    [],
  )

  layout.collection = state.collection
  layout.disabledKeys = state.disabledKeys

  useLayoutEffect(() => {
    // Sync loading state into the layout.
    if (layout.isLoading !== isLoading) {
      layout.isLoading = isLoading
      layout.virtualizer?.relayoutNow()
    }
  }, [layout, isLoading])

  return layout
}
